import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    ActionTypes,
    FetchAnalyticsRequestAction,
    fetchAnalyticsFailure,
    fetchAnalyticsSuccess,
} from './actions';

function fetchAnalyticsApi(periodDays: number) {
  return axios.get(`/api/email-analytics?periodDays=${periodDays}`);
}

function* fetchAnalyticsSaga(action: FetchAnalyticsRequestAction) {
  try {
    const response: Awaited<ReturnType<typeof fetchAnalyticsApi>> = yield call(
      fetchAnalyticsApi,
      action.payload.periodDays
    );
    yield put(fetchAnalyticsSuccess(response.data));
  } catch (error: any) {
    yield put(fetchAnalyticsFailure(error?.response?.data?.error || error.message || 'Failed to load analytics'));
  }
}

export default function* emailAnalyticsSaga() {
  yield takeLatest(ActionTypes.FETCH_ANALYTICS_REQUEST, fetchAnalyticsSaga);
}
